function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
module.exports = function (purchaseService) {
  var priceTaxFeeAdjuster = /*#__PURE__*/function () {
    function priceTaxFeeAdjuster(supplementalData) {
      _classCallCheck(this, priceTaxFeeAdjuster);
      this.name = "freeproducts";
      this.id = priceTaxFeeAdjuster.nextId;
      ++priceTaxFeeAdjuster.nextId;
      if (!supplementalData || !["uuid", "upc"].includes(supplementalData.type) || !supplementalData.list) {
        throw "Insufficient supplemental data supplied to freeproducts PTF.\nSupplemental data must be comprised of either {type: 'uuid', list: []} or  {type: 'upc', list: []} each with an optional limit field.\nFor example: {type: upc, list: ['021398239893'], limit: 1}";
      }

      // unless specified, we assume 1 of each uuid/UPC is eligible
      supplementalData.limit = supplementalData.limit || supplementalData.list.length;
      this.supplementalData = supplementalData;
      // must be the last thing ever to end up costing 0...
      this.priority = priceTaxFeeAdjuster.taxPriority - 10000;
      var offerStock = this.supplementalData.limit;
      for (var i = purchaseService.purchases.length - 1, p; p = purchaseService.purchases[i]; --i) {
        if (!offerStock) {
          break;
        }
        if (this.productShouldBeFree(p)) {
          /*
          /* In eCommerce apps one row can contain more the one redemption so those line was commented out . 
          /*
          // if it's on a multi-qty line, splice it out as a single-qty item
          if (p.qty > 1) {
            let freeP = JSON.parse(JSON.stringify(p));
            --p.qty;
            freeP.qty = 1;
            delete(freeP.uuid);
            purchaseService.purchases.push(freeP); // this actions also generates a new uuid
            i = purchaseService.purchases.length - 1; // reset the loop because we have a new item. free items will get skipped so no worries
            delete purchaseService.totals.cached.getIntPricelist; // delete the intPrice cache list
            purchaseService.getIntPricelist(); // so that calling it will generate a new one - needed for discount PTF calculation
            let temp = freeP.uuid;
            freeP.uuid = p.uuid;
            p.uuid = temp;
            p = freeP;
          }*/

          p.isFree = true;
          p.priceTaxFeeAdjustments = [];
          var manualdiscountPtf = purchaseService.priceTaxFeeAdjusters.find(function (a) {
            return a.name === "manualdiscount";
          });
          manualdiscountPtf.addManualdiscount(p, "percent", 1, this.supplementalData.source);
          --offerStock;
        }
      }
    }

    /*
    productShouldBeFree(p) {
      if (
        this.supplementalData.list.includes(p[this.supplementalData.type]) &&
        !p.isFree &&
        p.isRedemption
      ) {
        return true;
      }
    }
    */
    return _createClass(priceTaxFeeAdjuster, [{
      key: "productShouldBeFree",
      value: function productShouldBeFree(p) {
        return this.supplementalData.list.includes(p[this.supplementalData.type]) && !p.isFree && (p.isRedemption || !!p.redemptionPointsOfferId);
      }
    }, {
      key: "calculate",
      value: function calculate(productlist) {
        // required dummy function; all the heavy lifting is done by the "manualdiscount" PTF
      }
    }, {
      key: "calculateInt",
      value: function calculateInt(productlist) {
        // int values already populated
      }
    }]);
  }();
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require("../../purchaseservice.js"));